// Copyright (c) StrangeBee 2023

//eslint-disable-next-line
export const required = (value: any): boolean => {
    if (value === null) {
        return true;
    }
    if (typeof value === 'undefined') {
        return true;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return `${value}`.trim() === '';
};

export default {
    required,
} as Record<string, (...args: any[]) => any>;
